module.exports = __webpack_public_path__ + "static/media/csvIcon.84d8fd2c.svg";